module.exports = function() {
  return new Worker(__webpack_public_path__ + "e813b53f67435a5a56f2.worker.js");
};